var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4978 10.3727C23.4978 14.9288 19.8043 18.6223 15.2482 18.6223C10.692 18.6223 6.99854 14.9288 6.99854 10.3727C6.99854 5.81653 10.692 2.12305 15.2482 2.12305C19.8043 2.12305 23.4978 5.81653 23.4978 10.3727Z",
    fill: "url(#paint0_linear_1_13073)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99854 10.9961H16.9982",
    stroke: "#1D252B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99854 14.9961H16.9982",
    stroke: "#1D252B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98984 23.385C9.51039 24.8438 12.4754 25.3361 15.3322 24.7702C18.1889 24.2043 20.7424 22.6188 22.5165 20.3093C24.2906 17.9998 25.1642 15.1239 24.9745 12.2178C24.7848 9.31175 23.5447 6.57385 21.4854 4.51457C19.4261 2.4553 16.6882 1.2152 13.7822 1.0255C10.8761 0.835796 8.00022 1.70943 5.6907 3.48352C3.38119 5.25761 1.79569 7.81106 1.22979 10.6678C0.663902 13.5246 1.15625 16.4896 2.61504 19.0102L1.05136 23.6787C0.992602 23.8549 0.984075 24.044 1.02673 24.2247C1.06939 24.4055 1.16155 24.5708 1.29288 24.7021C1.42421 24.8334 1.58952 24.9256 1.77028 24.9683C1.95104 25.0109 2.14011 25.0024 2.3163 24.9436L6.98984 23.385Z",
    stroke: "#1D252B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_13073",
    x1: 15.2482,
    y1: 2.12305,
    x2: 15.2482,
    y2: 18.6223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.110b30ed9f33f9837082af04946b916f.svg";
export { ForwardRef as ReactComponent };